var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ai-catalog-list-header',{attrs:{"is-experiment":true}}),_vm._v(" "),_c('ai-catalog-mcp-server-list',{attrs:{"is-loading":_vm.isLoading,"items":_vm.aiCatalogMcpServers,"page-info":_vm.pageInfo,"empty-state-title":_vm.s__('AICatalog|No MCP servers yet'),"empty-state-description":_vm.s__(
        'AICatalog|Model Context Protocol servers extend agent capabilities with external tools and data sources.',
      )},on:{"next-page":_vm.handleNextPage,"prev-page":_vm.handlePrevPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }